import { render, staticRenderFns } from "./BlocksFilter.vue?vue&type=template&id=855929d6&"
import script from "./BlocksFilter.vue?vue&type=script&lang=js&"
export * from "./BlocksFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports